module.exports = __webpack_public_path__ + "img/drawer_safe_active.8ec4c52d.svg";